(function (app) {

    function timeLineEventMap($state, $filter) {
        return {
            ClientCreated: function (event, client) {
                return {
                    icon: "mdi-account-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added ${client.Person.FirstName} ${client.Person.LastName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [{
                        text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added ${client.Person.FirstName} ${client.Person.LastName}`
                    }]
                };
            },
            NoteAdded: function (event, client, onOpenScheduledTask, onOpenAppointment, onDeleteNote, onUpdateNote) {
                return {
                    icon: "mdi-message-text",
                    searchText: `note added, note, notes, note ${event.Description},  ${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} notes`,
                    deleteNote: function ($event) {
                        onDeleteNote(event.NoteId, $event);
                    },
                    updateNote: function (content, $event) {
                        onUpdateNote(event.NoteId, content, $event);
                    }
                };
            },
            TaskAdded: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the ${event.Description} task for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: event.CreatedBy.FirstName + " " + event.CreatedBy.LastName + " created the" },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: `task for ${client.Person.FirstName}.` }
                    ]
                };
            },
            TaskCompleted: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-check",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} completed the ${event.Description} task for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} completed the` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: `task for ${client.Person.FirstName}.` }
                    ]
                };
            },
            TaskReassigned: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} reassigned the task ${event.Description}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} reassigned the task` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: "." }
                    ]
                };
            },
            TaskClientUpdated: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the task ${event.Description}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the task` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: "." }
                    ]
                };
            },
            TaskClientAdded: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added ${client.Person.FirstName} to the task ${event.Description}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added ${client.Person.FirstName} to the task` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: "." }
                    ]
                };
            },
            TaskRescheduled: function (event, client, onOpenScheduledTask) {
                return {
                    icon: "mdi-clipboard-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} rescheduled the task ${event.Description} to ${$filter("date")(event.StartDate, "MMMM dd, yyyy")}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} rescheduled the task ` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenScheduledTask(event.ScheduledTaskId, $event);
                            }
                        },
                        { text: ` to ${$filter("date")(event.StartDate, "MMMM dd, yyyy")}.` }
                    ]
                };
            },
            MarketingEventAttended: function (event, client) {
                return {
                    CreatedOn: event.EventDate,
                    icon: "mdi-format-list-bulleted",
                    searchText: `Attended Event, ${event.Title},  ${$filter("date")(event.EventDate, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${client.Person.FirstName} ${client.Person.LastName} attended the event ${event.Title}.` }
                    ]
                };
            },
            AppointmentAdded: function (event, client, onOpenScheduledTask, onOpenAppointment) {
                return {
                    icon: "mdi-calendar-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added the ${event.Description} appointment, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added the` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenAppointment(event.AppointmentId, $event);
                            }
                        },
                        { text: "appointment." }
                    ]
                };
            },
            AppointmentCompleted: function (event, client, onOpenScheduledTask, onOpenAppointment) {
                return {
                    icon: "mdi-calendar-check",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} completed the ${event.Description} appointment, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} completed the` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenAppointment(event.AppointmentId, $event);
                            }
                        },
                        { text: "appointment." }
                    ]
                };
            },
            AppointmentAttendeeRemoved: function (event, client, onOpenScheduledTask, onOpenAppointment) {
                return {
                    icon: "i-calendar-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the ${event.Description} appointment, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenAppointment(event.AppointmentId, $event);
                            }
                        },
                        { text: "appointment." }
                    ]
                };
            },
            AppointmentMainAttendeeUpdated: function (event, client, onOpenScheduledTask, onOpenAppointment) {
                return {
                    icon: "i-calendar-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the appointment ${event.Description}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} removed ${client.Person.FirstName} from the appointment` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenAppointment(event.AppointmentId, $event);
                            }
                        },
                        { text: "." }
                    ]
                };
            },
            AppointmentRescheduled: function (event, client, onOpenScheduledTask, onOpenAppointment) {
                return {
                    icon: "i-calendar-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} rescheduled the appointment ${event.Description} to ${$filter("date")(event.StartDate, "MMMM dd, yyyy • h:mm a")}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} rescheduled the appointment` },
                        {
                            text: event.Description,
                            clickAction: function ($event) {
                                onOpenAppointment(event.AppointmentId, $event);
                            }
                        },
                        { text: `to ${$filter("date")(event.StartDate, "MMMM dd, yyyy • h:mm a")}.` }
                    ]
                };
            },
            CaseCreated: function (event, client) {
                return {
                    icon: "i-briefcase-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the case ${event.Description} for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the case ` },
                        {
                            text: event.Description,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: ` for ${client.Person.FirstName}.` }
                    ]
                };
            },
            InvestmentAccountCreated: function (event, client) {
                return {
                    icon: "i-account-card-details-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created investment account ${event.Description} for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created investment account ` },
                        {
                            text: event.Description,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: ` for ${client.Person.FirstName}.` }
                    ]
                };
            },
            AnnuityAccountCreated: function (event, client) {
                return {
                    icon: "i-account-card-details-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the annuity account ${event.Description} for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the annuity account ` },
                        {
                            text: event.Description,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: ` for ${client.Person.FirstName}.` }
                    ]
                };
            },
            LifeAccountCreated: function (event, client) {
                return {
                    icon: "i-account-card-details-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the life account ${event.Description} for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the life account ` },
                        {
                            text: event.Description,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: ` for ${client.Person.FirstName}.` }
                    ]
                };
            },
            LongTermCareAccountCreated: function (event, client) {
                return {
                    icon: "i-account-card-details-plus",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the long term account ${event.Description} for ${client.Person.FirstName}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} created the long term account ` },
                        {
                            text: event.Description,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: ` for ${client.Person.FirstName}.` }
                    ]
                };
            },
            CasePlanningNoteAdded: function (event) {
                return {
                    icon: "i-message-briefcase",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to case ${event.ParentObjectDetails}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to case ` },
                        {
                            text: event.ParentObjectDetails,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: "." }
                    ]
                };
            },
            InvestmentAccountNoteAdded: function (event) {
                return {
                    icon: "i-message-account",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to investment account ${event.ParentObjectDetails}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to investment account ` },
                        {
                            text: event.ParentObjectDetails,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: "." }
                    ]
                };
            },
            InsuranceAccountNoteAdded: function (event) {
                return {
                    icon: "i-message-account",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to insurance account ${event.ParentObjectDetails}, ${$filter("date")(event.CreatedOn, "MMMM dd, yyyy")}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} added a note to insurance account ` },
                        {
                            text: event.ParentObjectDetails,
                            link: $state.href("Home.Client.Case", { clientId: event.ClientId, caseId: event.CaseId }, { absolute: true })
                        },
                        { text: "." }
                    ]
                };
            },
            ClientTypeUpdated: function (event, client) {
                return {
                    icon: "mdi-account-alert",
                    searchText: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} changed ${client.Person.FirstName}'s status to ${event.ClientTypeName.toLowerCase()}`,
                    renderedText: [
                        { text: `${event.CreatedBy.FirstName} ${event.CreatedBy.LastName} changed ${client.Person.FirstName}'s status to ${event.ClientTypeName.toLowerCase()}` }
                    ]
                };
            }
        };
    }

    timeLineEventMap.$inject = ["$state", "$filter"];

    app.factory("timeLineEventMap", timeLineEventMap);

})(window.app); //jshint ignore:line